import './style.scss';
import Swiper from 'swiper';
import 'swiper/swiper.scss';
import {Navigation} from 'swiper/modules';

export function product_categories_block() {
    const block = document.querySelector('.product_categories_block');
    if (!block) return;

    const swiper = new Swiper(block?.querySelector('.product-categories-swiper'), {
        slidesPerView: 1.27,
        spaceBetween: 0,
        speed: 500,
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            },
            1280: {
                slidesPerView: 4,
            }
        },
        modules: [ Navigation],
        navigation: {
            nextEl: block.querySelector(".swiper-button-next"),
            prevEl: block.querySelector(".swiper-button-prev"),
        },
    });

}
